/**
 * Central social media handles. Update here and the homepage + footer follow.
 */
export const SOCIAL = {
  youtube: {
    handle: "souldadrob",
    channelId: "UC_MQ0hMMCKYURWQ1ees6GUA",
    channelUrl: "https://www.youtube.com/@souldadrob",
  },
  threads: {
    handle: "souldadrob",
    profileUrl: "https://www.threads.net/@souldadrob",
  },
  instagram: {
    handle: "souldadrob",
    profileUrl: "https://www.instagram.com/souldadrob/",
  },
  facebook: {
    profileUrl: "https://www.facebook.com/souldadrob",
  },
  linkedin: {
    profileUrl: "https://www.linkedin.com/in/rob-lasa-629993259/",
  },
} as const;